import React from "react";
import Employees  from "../modules/BiometricReport/Employees";
export default function BiometricReportPage() {
  return <Employees />;
}
